import React, { useState } from 'react';

const Category = (props) => {
    const { imageUrl, name } = props.category;

    let selectedClass = props.selectedCategory === props.index ? `lurebuilder-category-selected` : 'lurebuilder-category';
    return (
        <div className={selectedClass} id={`category-${props.index}`} onClick={() => props.handleClick(name)}>
            <img src={imageUrl} alt="category-image" className="lurebuilder-category-image" />
            <span className="lurebuilder-category-text">{name.toUpperCase()}</span>
        </div>
    );
}

export default Category;